import React, { useState, useEffect, useRef } from 'react';

const Menu = ({ 
  vista, 
  setVista, 
  tipoReporte, 
  setTipoReporte, 
  opcionesFacturas, 
  setOpcionesFacturas,
  identificacion,
  userRole
}) => {  
  const [subMenuAbierto, setSubMenuAbierto] = useState(false);
  const [subMenuFacturasAbierto, setSubMenuFacturasAbierto] = useState(false);
  const [subMenuHerramientasAbierto, setSubMenuHerramientasAbierto] = useState(false);
  const [acercaDeAbierto, setAcercaDeAbierto] = useState(false);
  const menuRef = useRef(null);
  const facturasRef = useRef(null);
  const herramientasRef = useRef(null);
  const acercaDeRef = useRef(null);

  // Estilos en objeto JavaScript para evitar problemas de configuración
  const styles = {
    wrapper: {
      background: 'linear-gradient(to right, #db86fdff, #1f40afff)',
      color: 'white',
      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
      padding: '0.5rem 0'
    },
    container: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    leftSection: {
      display: 'flex',
      gap: '0.5rem',
      marginLeft: '2cm'
    },
    rightSection: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '1.25rem',
      fontWeight: 'bold',
      marginRight: '1.5cm'
    },
    menuButton: {
      display: 'flex',
      alignItems: 'center',
      padding: '0.5rem 1rem',
      borderRadius: '0.375rem',
      fontSize: '0.875rem',
      fontWeight: '500',
      transition: 'all 0.2s',
      border: 'none',
      cursor: 'pointer'
    },
    menuButtonActive: {
      backgroundColor: '#1d4ed8',
      color: 'white'
    },
    menuButtonInactive: {
      backgroundColor: 'transparent',
      color: '#bfdbfe'
    },
    menuButtonHover: {
      backgroundColor: '#1d4ed8',
      color: 'white'
    },
    submenu: {
      position: 'absolute',
      right: '0',
      marginTop: '0.5rem',
      width: '12rem',
      borderRadius: '0.375rem',
      backgroundColor: 'white',
      boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
      zIndex: '100'
    },
    submenuItem: {
      display: 'block',
      width: '100%',
      textAlign: 'left',
      padding: '0.5rem 1rem',
      fontSize: '0.875rem',
      border: 'none',
      backgroundColor: 'transparent',
      cursor: 'pointer',
      transition: 'background-color 0.2s'
    },
    submenuItemActive: {
      backgroundColor: '#dbeafe',
      color: '#1d4ed8'
    },
    submenuItemInactive: {
      backgroundColor: 'transparent',
      color: '#374151'
    },
    submenuItemHover: {
      backgroundColor: '#f3f4f6'
    },
    acercaDeModal: {
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      backgroundColor: 'white',
      padding: '2rem',
      borderRadius: '0.5rem',
      boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
      zIndex: '50',
      maxWidth: '32rem',
      width: '90%',
      maxHeight: '80vh',
      overflowY: 'auto'
    },
    overlay: {
      position: 'fixed',
      top: '0',
      left: '0',
      right: '0',
      bottom: '0',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      zIndex: '40'
    },
    acercaDeTitulo: {
      fontSize: '1.5rem',
      fontWeight: 'bold',
      marginBottom: '1rem',
      color: '#1e40af'
    },
    acercaDeTexto: {
      marginBottom: '1rem',
      lineHeight: '1.6',
      color: '#374151'
    },
    cerrarBoton: {
      padding: '0.5rem 1rem',
      backgroundColor: '#2563eb',
      color: 'white',
      border: 'none',
      borderRadius: '0.375rem',
      cursor: 'pointer',
      fontWeight: '500',
      marginTop: '1rem'
    },
    acercaDeBoton: {
      display: 'flex',
      alignItems: 'center',
      padding: '0.5rem 1rem',
      borderRadius: '0.375rem',
      fontSize: '0.875rem',
      fontWeight: '500',
      transition: 'all 0.2s',
      border: 'none',
      cursor: 'pointer',
      backgroundColor: 'transparent',
      color: '#bfdbfe',
      marginLeft: '1rem'
    },
    contenidoContainer: {
      padding: '20px',
      marginTop: '20px'
    }
  };

  
  // Cerrar menús al hacer clic fuera de ellos
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setSubMenuAbierto(false);
      }
      if (facturasRef.current && !facturasRef.current.contains(event.target)) {
        setSubMenuFacturasAbierto(false);
      }
      if (herramientasRef.current && !herramientasRef.current.contains(event.target)) {
        setSubMenuHerramientasAbierto(false);
      }
      if (acercaDeRef.current && !acercaDeRef.current.contains(event.target)) {
        setAcercaDeAbierto(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const toggleSubMenu = () => {
    setSubMenuAbierto(!subMenuAbierto);
    setSubMenuFacturasAbierto(false);
    setSubMenuHerramientasAbierto(false);
    setAcercaDeAbierto(false);
  };

  const toggleSubMenuFacturas = () => {
    setSubMenuFacturasAbierto(!subMenuFacturasAbierto);
    setSubMenuAbierto(false);
    setSubMenuHerramientasAbierto(false);
    setAcercaDeAbierto(false);
  };

  const toggleSubMenuHerramientas = () => {
    setSubMenuHerramientasAbierto(!subMenuHerramientasAbierto);
    setSubMenuAbierto(false);
    setSubMenuFacturasAbierto(false);
    setAcercaDeAbierto(false);
  };

  const toggleAcercaDe = () => {
    setAcercaDeAbierto(!acercaDeAbierto);
    setSubMenuAbierto(false);
    setSubMenuFacturasAbierto(false);
    setSubMenuHerramientasAbierto(false);
  };

  const seleccionarTipoFacturas = (tipo) => {
    setOpcionesFacturas(tipo);

    if (tipo === 'BuscarDetalles') {
      setVista('detalles');
    } else if (tipo === 'inOutInventario') {
      setVista('inOutInventario');
    } else if (tipo === 'cotizaciones') {
      setVista('cotizaciones');
    } else {
      setVista('subir');
    }

    setSubMenuFacturasAbierto(false);
  };

  const seleccionarReporte = (tipo) => {
    setTipoReporte(tipo);
    setVista('reporte');
    setSubMenuAbierto(false);
  };

  const seleccionarHerramienta = (tipo) => {
    setVista(tipo); // Cambia la vista directamente
    setSubMenuHerramientasAbierto(false);
  };

  const contarDocumentos = async () => {
    try {
      // Importación dinámica para no cargar en todos lados
      const { collection, getCountFromServer } = await import('firebase/firestore');
      const { db } = await import('../firebase');
      
      const coll = collection(db, "EncabezadoFactura");
      const snapshot = await getCountFromServer(coll);
      
      alert(`Total de facturas almacenadas: ${snapshot.data().count}`);
      
    } catch (error) {
      console.error("Error al contar documentos:", error);
      alert("Error al contar las facturas.");
    }
    setSubMenuHerramientasAbierto(false);
  };

  return (
    <>
      <div style={styles.wrapper}>
        <nav style={styles.container}>
          {/* Elementos del menú a la izquierda con margen de 5cm */}
          <div style={styles.leftSection}>
            {/* Botón de Facturas con submenú */}
            <div style={{position: 'relative'}} ref={facturasRef}>
              <button
                onClick={toggleSubMenuFacturas}
                style={{
                  ...styles.menuButton,
                  ...(vista === 'subir' || vista === 'detalles' || vista === 'inOutInventario' ? styles.menuButtonActive : styles.menuButtonInactive)
                }}
                onMouseOver={(e) => {
                  if (vista !== 'subir' && vista !== 'detalles' && vista !== 'inOutInventario') {
                    e.target.style.backgroundColor = styles.menuButtonHover.backgroundColor;
                    e.target.style.color = styles.menuButtonHover.color;
                  }
                }}
                onMouseOut={(e) => {
                  if (vista !== 'subir' && vista !== 'detalles' && vista !== 'inOutInventario') {
                    e.target.style.backgroundColor = styles.menuButtonInactive.backgroundColor;
                    e.target.style.color = styles.menuButtonInactive.color;
                  }
                }}
              >
                <span style={{marginRight: '0.25rem'}}>📤</span>
                Archivo
                <span style={{marginLeft: '0.25rem', transform: subMenuFacturasAbierto ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s'}}>▼</span>
              </button>
              
              {subMenuFacturasAbierto && (
                <div style={styles.submenu}>
                  <button
                    onClick={() => seleccionarTipoFacturas('FacturasApp')}
                    style={{
                      ...styles.submenuItem,
                      ...(opcionesFacturas === 'FacturasApp' ? styles.submenuItemActive : styles.submenuItemInactive)
                    }}
                    onMouseOver={(e) => {
                      if (opcionesFacturas !== 'FacturasApp') {
                        e.target.style.backgroundColor = styles.submenuItemHover.backgroundColor;
                      }
                    }}
                    onMouseOut={(e) => {
                      if (opcionesFacturas !== 'FacturasApp') {
                        e.target.style.backgroundColor = styles.submenuItemInactive.backgroundColor;
                      }
                    }}
                  >
                    Gestionar Facturas XML
                  </button>
                  <button
                    onClick={() => seleccionarTipoFacturas('BuscaFactura')}
                    style={{
                      ...styles.submenuItem,
                      ...(opcionesFacturas === 'BuscaFactura' ? styles.submenuItemActive : styles.submenuItemInactive)
                    }}
                    onMouseOver={(e) => {
                      if (opcionesFacturas !== 'BuscaFactura') {
                        e.target.style.backgroundColor = styles.submenuItemHover.backgroundColor;
                      }
                    }}
                    onMouseOut={(e) => {
                      if (opcionesFacturas !== 'BuscaFactura') {
                        e.target.style.backgroundColor = styles.submenuItemInactive.backgroundColor;
                      }
                    }}
                  >
                    Buscar Facturas
                  </button>
                  <button
                    onClick={() => seleccionarTipoFacturas('BuscarDetalles')}
                    style={{
                      ...styles.submenuItem,
                      ...(opcionesFacturas === 'BuscarDetalles' ? styles.submenuItemActive : styles.submenuItemInactive)
                    }}
                    onMouseOver={(e) => {
                      if (opcionesFacturas !== 'BuscarDetalles') {
                        e.target.style.backgroundColor = styles.submenuItemHover.backgroundColor;
                      }
                    }}
                    onMouseOut={(e) => {
                      if (opcionesFacturas !== 'BuscarDetalles') {
                        e.target.style.backgroundColor = styles.submenuItemInactive.backgroundColor;
                      }
                    }}
                  >
                    Catalogar productos
                  </button>
                  <button
                    onClick={() => seleccionarTipoFacturas('inOutInventario')}
                    style={{
                      ...styles.submenuItem,
                      ...(opcionesFacturas === 'inOutInventario' ? styles.submenuItemActive : styles.submenuItemInactive)
                    }}
                    onMouseOver={(e) => {
                      if (opcionesFacturas !== 'inOutInventario') {
                        e.target.style.backgroundColor = styles.submenuItemHover.backgroundColor;
                      }
                    }}
                    onMouseOut={(e) => {
                      if (opcionesFacturas !== 'inOutInventario') {
                        e.target.style.backgroundColor = styles.submenuItemInactive.backgroundColor;
                      }
                    }}
                  >
                    Ajustes al Inventario
                  </button>
                  {/* Nueva opción para Cotizaciones */}
                  <button
                    onClick={() => seleccionarTipoFacturas('cotizaciones')}
                    style={{
                      ...styles.submenuItem,
                      ...(vista === 'cotizaciones' ? styles.submenuItemActive : styles.submenuItemInactive)
                    }}
                    onMouseOver={(e) => {
                      if (vista !== 'cotizaciones') {
                        e.target.style.backgroundColor = styles.submenuItemHover.backgroundColor;
                      }
                    }}
                    onMouseOut={(e) => {
                      if (vista !== 'cotizaciones') {
                        e.target.style.backgroundColor = styles.submenuItemInactive.backgroundColor;
                      }
                    }}
                  >
                    Cotizaciones
                  </button>
                  {/* Nueva opción para Recibos, después de Cotizaciones */}
                  <button
                    onClick={() => seleccionarHerramienta('sicRecibos')}
                    style={{
                      ...styles.submenuItem,
                      ...(vista === 'sicRecibos' ? styles.submenuItemActive : styles.submenuItemInactive)
                    }}
                    onMouseOver={(e) => {
                      if (vista !== 'sicRecibos') {
                        e.target.style.backgroundColor = styles.submenuItemHover.backgroundColor;
                      }
                    }}
                    onMouseOut={(e) => {
                      if (vista !== 'sicRecibos') {
                        e.target.style.backgroundColor = styles.submenuItemInactive.backgroundColor;
                      }
                    }}
                  >
                    Recibos
                  </button>
                </div>
              )}
            </div>

            {/* Botón de Herramientas con submenú */}
            <div style={{position: 'relative'}} ref={herramientasRef}>
              <button
                onClick={toggleSubMenuHerramientas}
                style={{
                  ...styles.menuButton,
                  ...(vista === 'parametros' || vista === 'importarArticulos' || vista === 'importarCatalogo' ? styles.menuButtonActive : styles.menuButtonInactive)
                }}
                onMouseOver={(e) => {
                  if (vista !== 'parametros' && vista !== 'importarArticulos' && vista !== 'importarCatalogo') {
                    e.target.style.backgroundColor = styles.menuButtonHover.backgroundColor;
                    e.target.style.color = styles.menuButtonHover.color;
                  }
                }}
                onMouseOut={(e) => {
                  if (vista !== 'parametros' && vista !== 'importarArticulos' && vista !== 'importarCatalogo') {
                    e.target.style.backgroundColor = styles.menuButtonInactive.backgroundColor;
                    e.target.style.color = styles.menuButtonInactive.color;
                  }
                }}
              >
                <span style={{marginRight: '0.25rem'}}>🛠️</span>
                Herramientas
                <span style={{marginLeft: '0.25rem', transform: subMenuHerramientasAbierto ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s'}}>▼</span>
              </button>
              
              {subMenuHerramientasAbierto && (
                <div style={styles.submenu}>
                  <button
                    onClick={() => seleccionarHerramienta('parametros')}
                    style={{
                      ...styles.submenuItem,
                      ...(vista === 'parametros' ? styles.submenuItemActive : styles.submenuItemInactive)
                    }}
                    onMouseOver={(e) => {
                      if (vista !== 'parametros') {
                        e.target.style.backgroundColor = styles.submenuItemHover.backgroundColor;
                      }
                    }}
                    onMouseOut={(e) => {
                      if (vista !== 'parametros') {
                        e.target.style.backgroundColor = styles.submenuItemInactive.backgroundColor;
                      }
                    }}
                  >
                    Parámetros
                  </button>
                  <button
                    onClick={() => seleccionarHerramienta('importarArticulos')}
                    style={{
                      ...styles.submenuItem,
                      ...(vista === 'importarArticulos' ? styles.submenuItemActive : styles.submenuItemInactive)
                    }}
                    onMouseOver={(e) => {
                      if (vista !== 'importarArticulos') {
                        e.target.style.backgroundColor = styles.submenuItemHover.backgroundColor;
                      }
                    }}
                    onMouseOut={(e) => {
                      if (vista !== 'importarArticulos') {
                        e.target.style.backgroundColor = styles.submenuItemInactive.backgroundColor;
                      }
                    }}
                  >
                    Catálogo de Productos
                  </button>
                  <button
                    onClick={() => seleccionarHerramienta('importarCatalogo')}
                    style={{
                      ...styles.submenuItem,
                      ...(vista === 'importarCatalogo' ? styles.submenuItemActive : styles.submenuItemInactive)
                    }}
                    onMouseOver={(e) => {
                      if (vista !== 'importarCatalogo') {
                        e.target.style.backgroundColor = styles.submenuItemHover.backgroundColor;
                      }
                    }}
                    onMouseOut={(e) => {
                      if (vista !== 'importarCatalogo') {
                        e.target.style.backgroundColor = styles.submenuItemInactive.backgroundColor;
                      }
                    }}
                  >
                    Agregar Catálogo
                  </button>
                  {userRole === 'admin' && (
                    <>
                      <button
                        onClick={() => seleccionarHerramienta('gestionUsuarios')}
                        style={{
                          ...styles.submenuItem,
                          ...(vista === 'gestionUsuarios' ? styles.submenuItemActive : styles.submenuItemInactive)
                        }}
                        onMouseOver={(e) => {
                          if (vista !== 'gestionUsuarios') {
                            e.target.style.backgroundColor = styles.submenuItemHover.backgroundColor;
                          }
                        }}
                        onMouseOut={(e) => {
                          if (vista !== 'gestionUsuarios') {
                            e.target.style.backgroundColor = styles.submenuItemInactive.backgroundColor;
                          }
                        }}
                      >
                        Gestión de Usuarios
                      </button>
                      {/* Nueva opción para Clientes */}
                      <button
                        onClick={() => seleccionarHerramienta('gestionClientes')}
                        style={{
                          ...styles.submenuItem,
                          ...(vista === 'gestionClientes' ? styles.submenuItemActive : styles.submenuItemInactive)
                        }}
                        onMouseOver={(e) => {
                          if (vista !== 'gestionClientes') {
                            e.target.style.backgroundColor = styles.submenuItemHover.backgroundColor;
                          }
                        }}
                        onMouseOut={(e) => {
                          if (vista !== 'gestionClientes') {
                            e.target.style.backgroundColor = styles.submenuItemInactive.backgroundColor;
                          }
                        }}
                      >
                        Gestión de Clientes
                      </button>
                      {/* Nueva opción para Proveedores */}
                      <button
                        onClick={() => seleccionarHerramienta('gestionProveedores')}
                        style={{
                          ...styles.submenuItem,
                          ...(vista === 'gestionProveedores' ? styles.submenuItemActive : styles.submenuItemInactive)
                        }}
                        onMouseOver={(e) => {
                          if (vista !== 'gestionProveedores') {
                            e.target.style.backgroundColor = styles.submenuItemHover.backgroundColor;
                          }
                        }}
                        onMouseOut={(e) => {
                          if (vista !== 'gestionProveedores') {
                            e.target.style.backgroundColor = styles.submenuItemInactive.backgroundColor;
                          }
                        }}
                      >
                        Gestión de Proveedores
                      </button>
                      <button
                        onClick={contarDocumentos}
                        style={{
                          ...styles.submenuItem,
                          ...styles.submenuItemInactive
                        }}
                        onMouseOver={(e) => {
                          e.target.style.backgroundColor = styles.submenuItemHover.backgroundColor;
                        }}
                        onMouseOut={(e) => {
                          e.target.style.backgroundColor = styles.submenuItemInactive.backgroundColor;
                        }}
                      >
                        Contar Facturas
                      </button>
                    </>
                  )}
                </div>
              )}
            </div>
            
            {/* Botón de Reporte con submenú */}
            <div style={{position: 'relative'}} ref={menuRef}>
              <button
                onClick={toggleSubMenu}
                style={{
                  ...styles.menuButton,
                  ...(vista === 'reporte' ? styles.menuButtonActive : styles.menuButtonInactive)
                }}
                onMouseOver={(e) => {
                  if (vista !== 'reporte') {
                    e.target.style.backgroundColor = styles.menuButtonHover.backgroundColor;
                    e.target.style.color = styles.menuButtonHover.color;
                  }
                }}
                onMouseOut={(e) => {
                  if (vista !== 'reporte') {
                    e.target.style.backgroundColor = styles.menuButtonInactive.backgroundColor;
                    e.target.style.color = styles.menuButtonInactive.color;
                  }
                }}
              >
                <span style={{marginRight: '0.25rem'}}>📑</span>
                Reportes
                <span style={{marginLeft: '0.25rem', transform: subMenuAbierto ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s'}}>▼</span>
              </button>
              
              {subMenuAbierto && (
                <div style={styles.submenu}>
                  <button
                    onClick={() => seleccionarReporte('comprasVentas')}
                    style={{
                      ...styles.submenuItem,
                      ...(tipoReporte === 'comprasVentas' ? styles.submenuItemActive : styles.submenuItemInactive)
                    }}
                    onMouseOver={(e) => {
                      if (tipoReporte !== 'comprasVentas') {
                        e.target.style.backgroundColor = styles.submenuItemHover.backgroundColor;
                      }
                    }}
                    onMouseOut={(e) => {
                      if (tipoReporte !== 'comprasVentas') {
                        e.target.style.backgroundColor = styles.submenuItemInactive.backgroundColor;
                      }
                    }}
                  >
                    Compras, Ventas, Gastos
                  </button>
                  <button
                    onClick={() => seleccionarReporte('inventario')}
                    style={{
                      ...styles.submenuItem,
                      ...(tipoReporte === 'inventario' ? styles.submenuItemActive : styles.submenuItemInactive)
                    }}
                    onMouseOver={(e) => {
                      if (tipoReporte !== 'inventario') {
                        e.target.style.backgroundColor = styles.submenuItemHover.backgroundColor;
                      }
                    }}
                    onMouseOut={(e) => {
                      if (tipoReporte !== 'inventario') {
                        e.target.style.backgroundColor = styles.submenuItemInactive.backgroundColor;
                      }
                    }}
                  >
                    Gestión de Inventario
                  </button>
                  <button
                    onClick={() => seleccionarReporte('estadoResultados')}
                    style={{
                      ...styles.submenuItem,
                      ...(tipoReporte === 'estadoResultados' ? styles.submenuItemActive : styles.submenuItemInactive)
                    }}
                    onMouseOver={(e) => {
                      if (tipoReporte !== 'estadoResultados') {
                        e.target.style.backgroundColor = styles.submenuItemHover.backgroundColor;
                      }
                    }}
                    onMouseOut={(e) => {
                      if (tipoReporte !== 'estadoResultados') {
                        e.target.style.backgroundColor = styles.submenuItemInactive.backgroundColor;
                      }
                    }}
                  >
                    Compra insumos
                  </button>
                  <button
                    onClick={() => seleccionarReporte('balanceGeneral')}
                    style={{
                      ...styles.submenuItem,
                      ...(tipoReporte === 'balanceGeneral' ? styles.submenuItemActive : styles.submenuItemInactive)
                    }}
                    onMouseOver={(e) => {
                      if (tipoReporte !== 'balanceGeneral') {
                        e.target.style.backgroundColor = styles.submenuItemHover.backgroundColor;
                      }
                    }}
                    onMouseOut={(e) => {
                      if (tipoReporte !== 'balanceGeneral') {
                        e.target.style.backgroundColor = styles.submenuItemInactive.backgroundColor;
                      }
                    }}
                  >
                    Balance General
                  </button>
                  <button
                    onClick={() => seleccionarReporte('flujoEfectivo')}
                    style={{
                      ...styles.submenuItem,
                      ...(tipoReporte === 'flujoEfectivo' ? styles.submenuItemActive : styles.submenuItemInactive)
                    }}
                    onMouseOver={(e) => {
                      if (tipoReporte !== 'flujoEfectivo') {
                        e.target.style.backgroundColor = styles.submenuItemHover.backgroundColor;
                      }
                    }}
                    onMouseOut={(e) => {
                      if (tipoReporte !== 'flujoEfectivo') {
                        e.target.style.backgroundColor = styles.submenuItemInactive.backgroundColor;
                      }
                    }}
                  >
                    Flujo de Efectivo
                  </button>
                </div>
              )}
            </div>
          </div>

          {/* Título a la derecha con margen de 5cm */}
          <div style={styles.rightSection}>
            <span style={{marginRight: '0.5rem'}}>📊</span>
            Sistema de Información Comercial
            
            {/* Botón Acerca de... */}
            <div style={{position: 'relative'}} ref={acercaDeRef}>
              <button
                onClick={toggleAcercaDe}
                style={{
                  ...styles.acercaDeBoton
                }}
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = styles.menuButtonHover.backgroundColor;
                  e.target.style.color = styles.menuButtonHover.color;
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = styles.menuButtonInactive.backgroundColor;
                  e.target.style.color = styles.menuButtonInactive.color;
                }}
              >
                <span style={{marginRight: '0.25rem'}}>ℹ️</span>
                Acerca de...
              </button>
            </div>
          </div>
        </nav>

        {/* Modal de Acerca de... */}
        {acercaDeAbierto && (
          <>
            <div style={styles.overlay} onClick={() => setAcercaDeAbierto(false)} />
            <div style={styles.acercaDeModal}>
              <h2 style={styles.acercaDeTitulo}>Sistema de Información Comercial</h2>
              <p style={styles.acercaDeTexto}>
                Esta aplicación está diseñada para gestionar la información comercial de su empresa,
                permitiendo el análisis de facturas, generación de reportes financieros y seguimiento
                del desempeño comercial.
              </p>
              <p style={styles.acercaDeTexto}>
                <strong>Funcionalidades principales:</strong>
              </p>
              <ul style={{...styles.acercaDeTexto, paddingLeft: '1.5rem'}}>
                <li>Gestión de facturas (subir y buscar)</li>
                <li>Búsqueda de detalles específicos</li>
                <li>Gestión de inventario</li>
                <li>Visualización de resúmenes comerciales</li>
                <li>Generación de reportes financieros</li>
                <li>Configuración de parámetros del sistema</li>
                <li>Importación de artículos</li>
                <li>Catálogo de productos</li>
              </ul>
              <p style={styles.acercaDeTexto}>
                <strong>Versión:</strong> 1.0.0
              </p>
              <button 
                style={styles.cerrarBoton}
                onClick={() => setAcercaDeAbierto(false)}
              >
                Cerrar
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default Menu;